import {
  FiEye,
  FiShoppingCart,
  FiArrowRight,
} from "react-icons/fi";
import { useNavigate } from "react-router-dom";

export default function RecentSalesOrders({ orders = [] }) {
  const navigate = useNavigate();

  return (
    <div className="bg-white border border-gray-100 rounded-3xl overflow-hidden">
      <div className="flex items-center justify-between p-6 border-b border-gray-100">
        <div>
          <h2 className="text-xl font-bold">Recent Sales Orders</h2>

          <p className="text-sm text-gray-500 mt-1">
            Latest customer orders
          </p>
        </div>

        <button
          onClick={() => navigate("/admindashboard/sales/orders/list")}
          className="text-primary-700 font-semibold flex items-center gap-2"
        >
          View All
          <FiArrowRight />
        </button>
      </div>

      <div className="divide-y divide-gray-100">
        {orders.length ? (
          orders.map((order) => (
            <div
              key={order.id}
              className="p-5 hover:bg-gray-50 transition"
            >
              <div className="flex justify-between items-start gap-4">
                <div className="flex gap-4 min-w-0">
                  <div className="h-12 w-12 shrink-0 rounded-2xl bg-primary-50 text-primary-700 flex items-center justify-center">
                    <FiShoppingCart size={20} />
                  </div>

                  <div className="min-w-0">
                    <h4 className="font-semibold truncate">
                      {order.salesOrderNumber}
                    </h4>

                    <p className="text-sm text-gray-500 mt-1 truncate">
                      {order.customer?.fullName || "—"}
                    </p>

                    <p className="text-xs text-gray-400 mt-1 truncate">
                      {order.store?.name || "—"}
                    </p>
                  </div>
                </div>

                <div className="text-right shrink-0">
                  <h3 className="font-bold text-lg">
                    {formatMoney(order.totalAmount)}
                  </h3>

                  <p className="text-xs text-gray-500">
                    {order._count?.items || 0} Items
                  </p>
                </div>
              </div>

              <div className="flex items-center justify-between mt-5">
                <span className="text-xs text-gray-400">
                  {formatDateTime(order.orderDate)}
                </span>

                <div className="flex items-center gap-3">
                  <Status status={order.status} />

                  <button
                    onClick={() =>
                      navigate(`/admindashboard/sales/orders/${order.id}`)
                    }
                    className="h-9 w-9 rounded-lg border border-gray-200 flex items-center justify-center hover:bg-primary-700 hover:text-white transition"
                    title="View sales order"
                  >
                    <FiEye />
                  </button>
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="py-16 text-center text-gray-500">
            No sales orders found.
          </div>
        )}
      </div>
    </div>
  );
}

function Status({ status }) {
  const styles = {
    DRAFT: "bg-gray-100 text-gray-700",
    CONFIRMED: "bg-blue-100 text-blue-700",
    PARTIALLY_DELIVERED: "bg-yellow-100 text-yellow-700",
    DELIVERED: "bg-green-100 text-green-700",
    CANCELLED: "bg-red-100 text-red-700",
  };

  return (
    <span
      className={`px-3 py-1 rounded-full text-xs font-semibold ${
        styles[status] || "bg-gray-100 text-gray-700"
      }`}
    >
      {toTitle(status)}
    </span>
  );
}

function formatMoney(value) {
  return `₹${Number(value || 0).toLocaleString("en-IN", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  })}`;
}

function formatDateTime(value) {
  if (!value) return "—";

  const date = new Date(value);
  const today = new Date();

  const isToday = date.toDateString() === today.toDateString();

  if (isToday) {
    return `Today · ${date.toLocaleTimeString("en-IN", {
      hour: "2-digit",
      minute: "2-digit",
    })}`;
  }

  return date.toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
}

function toTitle(value = "") {
  return value
    .toLowerCase()
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}